import moment from "moment/moment";
import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";
import { prepareBaseGetListParams } from "../utils/fetch/PrepareBaseGetListParams";
import { prepareEnumSearchParams } from "../utils/fetch/PrepareEnumSearchParams";
import { pickFields } from "../utils/pickFields";


const createLocationPayload = (location) => {
    const country = location?.country?.code;
    const status = location?.status?.id;
    const l = pickFields(location, {
        externalSystemId: true,
        name: true,
        city: true,
        street: true,
        buildingNumber: true,
        postalCode: true,
        status: true,
        latitude: true,
        longitude: true,
        supervisorContactDetails: true,
        supervisorName: true,
        supervisorPhone: true,
        supervisorOperationHours: true,
        supervisorNotes: true,
        priority: true,
        status: true
    });
    l.country = country;

    if (location.operatingHoursEnabled && location.operatingHours) {
        
        l.operationHours = Object.entries(location.operatingHours)
            .map(([dayId, data]) => {
                
                const safeStart = data.startTime ? data.startTime.substring(0, 5) : null;
                const safeEnd = data.endTime ? data.endTime.substring(0, 5) : null;

                return {
                    dayOfWeek: dayId,
                    startTime: safeStart,
                    endTime: safeEnd,
                    enabled: data.enabled
                };
            });
    }
    else {
        l.operationHours = [];
    }

    //l.status = status;
    return l;
}

export const LocationService = {

    getList: (criteria, enums) => {
        const params = prepareBaseGetListParams(criteria);

        prepareEnumSearchParams(
            criteria.baseQuery,
            params,
            enums
        );

        params.set(
            'only_active',
            String(Boolean(criteria.showOnlyActive))
        );

        return fetchWithAuth(
            `/portal/locations?${params.toString()}`,
            { method: 'GET' }
        );
    },

    getCurrentMerchantNames: () => {
        return fetchWithAuth('/portal/locations/current-merchant-names', { method: 'GET' });
    },
    getNamesWithDevices: () => {
        return fetchWithAuth('/portal/locations/names-with-devices', { method: 'GET' });
    },
   
    getLocationsForMap: (filters = {}) => {
        console.log('LocationService::getLocationsForMap-filters', filters);
        const params = new URLSearchParams();

        if (filters.search) {
            params.append('search', filters.search);
        }
        if (filters.name && Array.isArray(filters.name)) {
            filters.name.forEach(val => {
                if (val && val.trim() !== '') params.append('names', val);
            });
        }
        if (filters.city && Array.isArray(filters.city)) {
            filters.city.forEach(val => {
                if (val && val.trim() !== '') params.append('cities', val);
            });
        }
        if (filters.street && Array.isArray(filters.street)) {
            filters.street.forEach(val => {
                if (val && val.trim() !== '') params.append('streets', val);
            });
        }

        const url = params.toString() ? `/portal/locations/map?${params.toString()}` : '/portal/locations/map';
        return fetchWithAuth(url, { method: 'GET' });
    },

    getStatusList: () => {
        return fetchWithAuth('/portal/locations/status-list', { method: 'GET' });
    },
    getPriorityList: () => {
        return fetchWithAuth('/portal/locations/priority-list', { method: 'GET' });
    },
    getTechniciansList: () => {
        return fetchWithAuth('/portal/locations/technicians-list', { method: 'GET' });
    },
    get: (locationId) => {
        return fetchWithAuth(`/portal/locations/${locationId}`, { method: 'GET' });
    },
    getMapDetails: (locationId) => {
        return fetchWithAuth(`/portal/locations/${locationId}/map-details`, { method: 'GET' });
    },
    create: (location) => {
        const payload = createLocationPayload(location);
        return fetchWithAuth('/portal/locations', { method: 'POST', body: JSON.stringify(payload), forceRefreshToken: true });
    },
    update: (locationId, location) => {
        const payload = createLocationPayload(location);
        return fetchWithAuth(`/portal/locations/${locationId}`, { method: 'PUT', body: JSON.stringify(payload) });
    },
    delete: (locationId) => {
        return fetchWithAuth(`/portal/locations/${locationId}`, { method: 'DELETE' });
    },
    deactivate: (locationId) => {
        return fetchWithAuth(`/portal/locations/${locationId}/deactivate`, { method: 'PUT' });
    },
    activate: (locationId) => {
        return fetchWithAuth(`/portal/locations/${locationId}/activate`, { method: 'PUT' });
    },
    /**
     * @param {{ signal?: AbortSignal }} [options] - pass a signal to cancel the request
     *   (e.g. when the dialog that requested it closes).
     * Sends an opaque X-Request-Id that is reused if the request is retried after a 401.
     */
    getAllLocations: ({ signal } = {}) => {
        return fetchWithAuth('/portal/locations/list-all-locations', {
            method: 'GET',
            signal,
            requestId: true,
        });
    },
    getAllCities: () => {
        return fetchWithAuth('/portal/locations/list-all-cities', { method: 'GET' });
    },
    downloadTemplate: () => {
        return fetchWithAuth(`/portal/locations/import/template`, { method: 'GET', });
    },
    importLocations: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return fetchWithAuth(`/portal/locations/import`, { method: 'POST', body: formData }, true);
    },
    commitImport: (request) => {
        return fetchWithAuth(`/portal/locations/import/commit`, { method: 'POST', body: JSON.stringify(request), forceRefreshToken: true });
    }
}